/**
 * US phone input mask: (888) 888-8888
 * Formats as the operator types; never invents digits.
 */

export function phoneDigitsOnly(value: string | null | undefined): string {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, 10);
}

/** Progressive display format for a phone input field. */
export function formatUsPhoneInput(value: string | null | undefined): string {
  const digits = phoneDigitsOnly(value);
  if (!digits) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
